import axios from '../../utils/AxiosUtils';
import i18n from '../../i18next';
import { DEFAULT_PAGE_SIZE } from '../../utils/Constants';
import MessageUtils from "../../utils/MessageUtils";

import {
    LOADING,
    LOAD_JOB_HISTORY_SUCCESS,
    LOAD_JOB_DETAILS_SUCCESS,
    LOAD_JOB_ITEMS_SUCCESS,
    LOAD_JOB_PAYLOAD_SUCCESS,
    CLEAR_JOB_DETAILS, CLEAR_PAYLOAD
} from '../types';
import {push} from "connected-react-router";

export const loadJobHistory = (currentPageNumber=1, searchQuery) => {
    return(dispatch, getState) => {
        
        doLoadJobHistory(currentPageNumber, dispatch, getState, searchQuery);
    }
}

const doLoadJobHistory = (currentPageNumber, dispatch, getState, searchQuery) => {
    dispatch({ type: LOADING, payload: true });


    let jobIdParameter = '';
    let brandNameParameter = '';
    let locationParameter = '';
    let startedAtParameter = '';
    let actionParameter = '';
    let statusParameter = '';

    if(searchQuery !== undefined){
        if(searchQuery.jobId !== undefined && searchQuery.jobId !== ''){
            jobIdParameter = `&id=${searchQuery.jobId}`
        }
        if(searchQuery.brandName !== undefined && searchQuery.brandName !== ''){
            brandNameParameter = `&brandName=${searchQuery.brandName}`
        }
        if(searchQuery.location !== undefined && searchQuery.location !== ''){
            locationParameter = `&location=${searchQuery.location}`
        }
        if(searchQuery.startedAt !== undefined && searchQuery.startedAt !== ''){
            startedAtParameter = `&startedAt=${searchQuery.startedAt}`
        }
        if(searchQuery.action !== undefined && searchQuery.action !== ''){
            actionParameter = `&action=${searchQuery.action}`
        }
        if(searchQuery.status !== undefined && searchQuery.status !== ''){
            statusParameter = `&status=${searchQuery.status}`
        }
    }

    const url = `/job/search?page=${currentPageNumber - 1}&size=${DEFAULT_PAGE_SIZE}${jobIdParameter}${brandNameParameter}${locationParameter}${startedAtParameter}${actionParameter}${statusParameter}`;

    axios().get(url)
        .then(response => loadJobHistorySuccess(dispatch, response))
        .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:jobHistoryActions.loadJobsFailure')));
}

const loadJobHistorySuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_JOB_HISTORY_SUCCESS, payload: response.data });
}

export const loadJobDetails = (jobId) => {
    return(dispatch, getState) => {
        doLoadJobDetails(jobId, dispatch, getState);
    }
}

const doLoadJobDetails = (jobId, dispatch, getState) => {
    dispatch({ type: LOADING, payload: true });

    const url = `/job/${jobId}`

    axios().get(url)
        .then(response => loadJobDetailsSuccess(dispatch, response))
        .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:jobHistoryActions.loadJobsFailure')));
}

const loadJobDetailsSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });

    const selectedJob = {
        id: response.data.id,
        action: response.data.action,
         duration: response.data.duration,
        restaurantName: response.data.restaurantName,
        scheduledAt:response.data.scheduledAt,
        startedAt: response.data.startedAt,
         status: response.data.status,
        type: response.data.type,
        userName: response.data.userName,
    };

    dispatch({ type: LOAD_JOB_DETAILS_SUCCESS, payload: selectedJob });
    dispatch({ type: LOAD_JOB_ITEMS_SUCCESS, payload: response.data.items });
    dispatch({ type: LOAD_JOB_PAYLOAD_SUCCESS, payload: response.data.payload });

    dispatch(push(`/job-history`));
}

export const clearJobDetails = () => {

    return(dispatch) => {
        dispatch({ type: CLEAR_JOB_DETAILS });
        dispatch({ type: CLEAR_PAYLOAD, payload: i18n.t('actions:jobPayloadActions.loadingPayload')});
    }
}



// WEBPACK FOOTER //
// ./src/actions/jobhistory/JobHistoryActions.js